// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "@firebase/messaging";
import { firebaseCredentials } from "../share/constants/enums";

let messaging = null;

const initializeMessaging = async () => {
  if (await isSupported()) {
    const app = initializeApp(firebaseCredentials);
    messaging = getMessaging(app);
  }
};

export const getFirebaseMessaging = async () => {
  if (!messaging) {
    await initializeMessaging();
  }
  return messaging;
};
